import React, { useState } from "react";
import { Tabs } from "antd";
import QcRules from "./QCGeneral/QcRules";
import CustomerRange from "./QCRange/CustomerRange";
import CustomerRules from "./QCRules/CustomerRules";

import "./QcRulesTab.css";

const items = [
  {
    key: "1",
    label: "General",
    children: <QcRules />,
  },
  {
    key: "2",
    label: "Customer Ranges",
    children: <CustomerRange />,
  },
  {
    key: "3",
    label: "Customer Rules",
    children: <CustomerRules />,
  },
];

export default function QcRulesTab() {
  const [activeKey, setActiveKey] = useState("1");

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <Tabs
      className="QcRulesTab QCContainer"
      activeKey={activeKey}
      onChange={handleTabChange}
      items={items}
      destroyInactiveTabPane
    />
  );
}
